module.exports = __webpack_public_path__ + "static/img/a107.28054d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a107.jpg
// module id = 3bOJ
// module chunks = 0